export const splashScreenZIndex = 1;

export const modalFirstLevelZIndex = 3;
export const modalSecondLevelZIndex = 4;

export const uiBlockingBackdropZIndex = 5;
export const uiBlockingInvisibleBackdropZIndex = 6;
